export const AMPLITUDE_EVENTS = {
	WEBAPP_LANDING_SCROLLED: 'webapp landing scrolled',
	WEBAPP_LANDING_SHOWN: 'webapp landing shown',
	MEDIA_GALLERY_SHOWN: 'media gallery shown',
	MEDIA_ADDED: 'media added',
	HEADER_MENU_SHOWN: 'header menu shown',
	HEADER_MENU_PRESSED: 'header menu pressed',
	HEADER_SUBFEATURE_PRESSED: 'header subfeature pressed',
	FOOTER_MENU_SHOWN: 'footer menu shown',
	FOOTER_SUBFEATURE_PRESSED: 'footer subfeature pressed',
	ALL_TOOLS_CATEGORY_SELECTED: 'all tools category selected',
	ALL_TOOLS_SEARCH_OPENED: 'all tools search opened',
	ALL_TOOLS_SEARCH_USED: 'all tools search used',
	ALL_TOOLS_SEARCH_RESULT_PRESSED: 'all tools search result pressed',
	ALL_TOOLS_SEARCH_CLOSED: 'all tools search closed',
	ALL_TOOLS_FEATURE_SELECTED: 'all tools feature selected',
	ALL_TOOLS_SUBFEATURE_SELECTED: 'all tools subfeature selected',
	SEE_ALL_PRESSED: 'see all pressed',
	EMAIL_POPUP_SHOWN: 'email popup shown',
	EMAIL_POPUP_COMPLETED: 'email popup completed',
	// Same names as the web app's paywall, so both ends of the funnel report
	SUBSCRIPTION_SHOWN: 'subscription shown',
	SUBSCRIPTION_PAGE_SCROLLED: 'subscription page scrolled',
};

export const AMPLITUDE_EVENT_PROPERTIES = {
	CONTEXT: 'context',
	SUBSCRIPTION: 'subscription',
	IS_TRIAL: 'is trial',
};

export const AMPLITUDE_EVENT_CONTEXT = {
	PRICING_LANDING: 'pricing-fill-landing',
};
